<template>
  <chart-card :loading="loading" :title="$t(keyMessage[productSoldType])">
    <a-tooltip :title="$t('message.views.workbench.dashboardDescription.channelProductSold')" slot="action">
      <a-icon type="info-circle-o"/>
    </a-tooltip>
    <div>
      <mini-bar :data-source="productSoldData"/>
    </div>
    <template slot="footer">
      <!--      Lazada：<span style="margin-left:5px;margin-right:30px">60%</span>AE：<span style="margin-left:5px;">40%</span>-->
      <template v-for="(value,key) in channelSumData">
        <span v-if="key!='ALL'" style="margin-right: 20px">{{key}}: {{ Math.floor(value / channelSumData.ALL * 10000) / 100 }}%</span>
      </template>
    </template>
  </chart-card>
</template>

<script>
import {
  ChartCard,
  MiniArea,
  Trend,
  MiniBar
} from '../../../components'
import request from '../../../utils/request'

const keyMessage = {
  ITEM_SOLD: 'message.views.workbench.channelItemSold',
  ORDER_QUANTITY: 'message.views.workbench.channelOrderQuantity'
}
export default {
  name: 'ChannelProductSoldCard',
  components: {
    ChartCard,
    MiniArea,
    Trend,
    MiniBar
  },
  computed: {
    channelSumData () {
      let productSoldData = this.productSoldData
      let result = {}
      console.log('start productSoldData', productSoldData)
      let all = 0
      for (let index in productSoldData) {
        let channel = productSoldData[index].channel
        console.log('productSoldDataKey', index, result[channel])
        if (result[channel] !== undefined) {
          result[channel] = result[channel] + productSoldData[index].quantity
        } else {
          result[channel] = productSoldData[index].quantity
        }
        all += productSoldData[index].quantity
      }
      result.ALL = all
      console.log('channelSumData', result)
      return result
    }
  },
  data () {
    return {
      productSoldData: [],
      keyMessage,
      loading: true
    }
  },
  props: {
    productSoldType: {
      type: String,
      default: 'ITEM_SOLD'
    }
  },
  mounted () {
    this.getChannelProductSoldData()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  methods: {
    getChannelProductSoldData () {
      request({
        url: '/dashboard/getChannelProductSoldData',
        method: 'get',
        params: {
          productSoldDataType: this.productSoldType
        }
      }).then(response => {
        // response.data = json
        console.log('getChannelProductSoldData Result', response)
        this.productSoldData = response.data.model && response.data.model.map((item) => {
          return {
            channel: item.channel,
            dateKey: item.dateKey,
            quantity: Number.parseInt(item.quantity)
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ChannelProductSoldCard.vue